import { motion } from "framer-motion";
import { CATEGORIES } from "../config";
import { CardBack } from "./CardBack";
import { CardFront } from "./CardFront";

// 3D flip card. Controlled by parent via `flipped`.
export const QuestionCard = ({ question, flipped, onFlip }) => {
  const displayCategory = question?.seedKey?.startsWith("fun-") ? "FUN" : question.category;
  const theme = CATEGORIES[displayCategory] || CATEGORIES.PERSONAL;

  return (
    <div className="card-perspective">
      <motion.div
        className={`card-3d card-theme-${displayCategory?.toLowerCase()} ${flipped ? "is-flipped" : ""}`}
        data-testid="flip-card"
        onClick={() => !flipped && onFlip()}
        animate={{ rotateY: flipped ? 180 : 0 }}
        transition={{ type: "spring", stiffness: 200, damping: 20 }}
        style={{
          "--card-accent": theme.color,
          transformStyle: "preserve-3d",
          WebkitTransformStyle: "preserve-3d",
          willChange: "transform",
        }}
      >
        <CardBack category={displayCategory} />
        <CardFront question={question} />
      </motion.div>
    </div>
  );
};

export default QuestionCard;
